import { useEffect, useState } from "react";
import api, { fmtNZD, BACKEND_URL } from "@/lib/api";

export default function Reports() {
  const [projects, setProjects] = useState([]);
  const [pid, setPid] = useState("");
  const [pos, setPos] = useState(null);
  const [labour, setLabour] = useState(null);
  const [fin, setFin] = useState(null);

  useEffect(() => { api.get("/projects").then(r => setProjects(r.data)); }, []);

  async function load() {
    if (!pid) return;
    const [p, l, f] = await Promise.all([
      api.get(`/reports/position/${pid}`),
      api.get("/reports/labour", { params: { project_id: pid } }),
      api.get("/reports/financial"),
    ]);
    setPos(p.data); setLabour(l.data); setFin(f.data);
  }
  async function positionPdf() {
    const r = await api.get(`/reports/position/${pid}.pdf`, { responseType: "blob" });
    window.open(URL.createObjectURL(r.data), "_blank");
  }
  async function financialCsv() {
    const r = await api.get("/reports/financial.csv", { responseType: "blob" });
    const u = URL.createObjectURL(r.data); const a = document.createElement("a");
    a.href = u; a.download = "financial.csv"; a.click();
  }

  return (
    <div className="space-y-3" data-testid="reports-page">
      <h1 className="text-2xl">Reports</h1>
      <div className="card flex gap-2 items-end flex-wrap">
        <label className="text-sm">Project
          <select className="input" value={pid} onChange={e=>setPid(e.target.value)} data-testid="rpt-project">
            <option value="">—</option>
            {projects.map(p=>(<option key={p.id} value={p.id}>{p.name}</option>))}
          </select>
        </label>
        <button className="btn-silver" onClick={load} data-testid="btn-run-reports">Run</button>
        {pid && <a href="#" className="btn-ghost text-sm" data-testid="btn-position-pdf"
          onClick={e=>{e.preventDefault(); positionPdf();}}>Position PDF</a>}
        <a href="#" className="btn-ghost text-sm" data-testid="btn-financial-csv"
          onClick={e=>{e.preventDefault(); financialCsv();}}>Financial CSV</a>
      </div>
      {pos && (
        <div className="card" data-testid="position-report">
          <h2 className="text-silver mb-2">Position — {pos.project?.name}</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <Stat label="Original contract" v={fmtNZD(pos.contract?.original)}/>
            <Stat label="Approved variations" v={fmtNZD(pos.contract?.approved_variations)}/>
            <Stat label="Current contract" v={fmtNZD(pos.contract?.current_contract_total)} bold/>
            <Stat label="Costs so far" v={fmtNZD(pos.costs?.costs_so_far)}/>
            <Stat label="Committed" v={fmtNZD(pos.costs?.committed)}/>
            <Stat label="Forecast final cost" v={fmtNZD(pos.costs?.forecast_final_cost)}/>
            <Stat label="Invoiced" v={fmtNZD(pos.client?.invoiced)}/>
            <Stat label="Profit to date" v={fmtNZD(pos.profit?.profit_to_date)}/>
            <Stat label="Forecast profit" v={fmtNZD(pos.profit?.forecast_profit)} bold/>
          </div>
        </div>
      )}
      {labour && (
        <div className="card">
          <h2 className="text-silver mb-2">Labour</h2>
          <div className="text-silver">Total hours: {labour.total_hours}</div>
          <table className="table mt-2"><thead><tr><th>Date</th><th>Project</th><th>Task</th><th>Hours</th></tr></thead>
            <tbody>{labour.rows.map((r,i)=>(<tr key={i}><td>{r.work_date}</td><td>{r.project_name}</td><td>{r.task}</td><td>{r.hours}</td></tr>))}</tbody></table>
        </div>
      )}
      {fin && (
        <div className="card">
          <h2 className="text-silver mb-2">Financial — budget vs actual</h2>
          <table className="table"><thead><tr><th>Project</th><th>Contract</th><th>Budget</th><th>Actual</th></tr></thead>
            <tbody>{fin.rows.map(r=>(<tr key={r.project_id}><td>{r.name}</td><td>{fmtNZD(r.contract_amount)}</td><td>{fmtNZD(r.budget_net_cost)}</td><td>{fmtNZD(r.actual_costs)}</td></tr>))}</tbody></table>
        </div>
      )}
    </div>
  );
}
function Stat({ label, v, bold }) {
  return <div className="p-3 rounded border border-neutral-800">
    <div className="text-xs text-silver">{label}</div>
    <div className={`${bold ? "text-xl text-silver font-bold" : "text-lg"}`}>{v}</div>
  </div>;
}
